<template>
  <ModalDialog
    ref="dialog"
    :maxWidth="170"
    :displayCancelButton="false"
    :posX="posX"
    :posY="posY"
    :dlgStyle="dlgStyle"
    :displayOkButton="false"
  >
    <div class="dlg-choice">
      <div class="text-size-16 text-weight-semi-bold">
        {{ $t('choiceDialog.headline') }}
      </div>
      <div v-if="0" class="text-size-12 mb-2">
        {{ $t('choiceDialog.text') }}
      </div>
      <div class="p-0 mt-2 justify-content-between">
        <div
          @click="select(1)"
          class="choice-column m-1 pointer align-items-center"
        >
          <div
            class="choice-border d-flex justify-content-center align-items-center"
          >
            <div class="text-accepted">
              <font-awesome-icon :icon="['fas', 'check']" />
            </div>
          </div>
          <div class="mt-1 text-center">
            {{ $t('general.yes') }}
          </div>
        </div>
        <div
          @click="select(0)"
          class="choice-column m-1 pointer align-items-center"
        >
          <div
            class="choice-border d-flex justify-content-center align-items-center"
          >
            <font-awesome-icon :icon="['fas', 'times']" />
          </div>
          <div class="mt-1">
            {{ $t('general.no') }}
          </div>
        </div>
        <div
          v-if="mayBeAnswersEnabled"
          @click="select(2)"
          class="choice-column m-1 pointer align-items-center"
        >
          <div
            class="choice-border d-flex justify-content-center align-items-center"
          >
            <div class="text-accepted">
              (<font-awesome-icon :icon="['fas', 'check']" />)
            </div>
          </div>
          <div class="mt-1 "  v-html="$t('general.maybe2')"></div>
        </div>
        <div
          v-if="doNotKnowYetEnabled"
          @click="select(-2)"
          class="choice-column m-1 pointer align-items-center"
        >
          <div
            class="choice-border d-flex justify-content-center align-items-center"
          >
            <font-awesome-icon :icon="['fas', 'question']" />
          </div>
          <div class="mt-1" v-html="$t('general.dontknow2')"></div>
        </div>

        <div class="cancel-button">
          <BtnLink 
          @click.native="closeModal"
          :label="$t('general.cancel')"
          />

        </div>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
import { renderMixin } from '../mixins/RenderMixins';

export default {
  name: 'ModalChoiceDialog',

  data() {
    return {
      posX: 0,
      posY: 0,
    };
  },
  props: ['editedChoice'],
  watch: {
    editedChoice: function (newVal, oldVal) {
      // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
      this.posX = newVal.posX;
      this.posY = newVal.posY;
    },
  },
  mixins: [renderMixin],

  computed: {
    // dlgStyle() {
    //   console.log('Modal Dialog style update:', this.posX, this.posY);
    //   if (this.posY) {
    //     if (this.mobileView) {
    //       const top = this.posY - 180;
    //       const s = ';margin:' + top + 'px auto';
    //       return s;
    //     }
    //     const left = this.posX - 180;
    //     const s = ';left:' + left + 'px; top:' + this.posY + 'px';
    //     console.log('Modal Dialog style:', s);
    //     return s;
    //   }
    //   return 'margin:' + this.posX + 'px auto';
    // },

    dlgStyle() {
      console.log('Modal Dialog style update:', this.posX, this.posY);

      const padding = 20;
      const dlgWidth = 170;
      const dlgHeight = 265;

      if (this.mobileView) {
        // const top = this.posY - 180;
        // const s = ';margin:' + top + 'px auto';
        let x = window.innerWidth - dlgWidth - padding;

        let y = this.posY - dlgHeight /2; 

        if( y < 0 ) y = padding;

        const s = ';left:' + x + 'px; top:' + y + 'px';
        console.log('Modal Dialog style:', s, window.innerHeight);
        return s;
      }

      let x = this.posX - dlgWidth / 2;
      let y = this.posY  - 80;  // 50% of the submitton row height


      const s = ';left:' + x + 'px; top:' + y + 'px';
      console.log('Modal Dialog style:', s, window.innerHeight);
      return s;
    },

    //  dlgStyle() {
    //       const dlgWidth = 360;

    //       const dlgHeight = (360 + 100);
    //       const padding = 20;

    //       let left = this.posX;
    //       if (left + dlgWidth + padding > window.innerWidth)
    //         left = window.innerWidth - dlgWidth - padding;

    //       let top = this.posY;
    //       if (top + dlgHeight + padding > window.innerHeight)
    //         top = window.innerHeight - dlgHeight - padding;

    //       const s = ';left:' + left + 'px; top:' + top + 'px';
    //       console.error('Modal Dialog style:', s, this.modalDialog);
    //       return s;
    //     },

    mobileView() {
      return this.$store.state.mobileView;
    },
  },

  methods: {
    openModal(event) {
      this.$refs.dialog.openModal(event);
    },

    closeModal() {
      this.$refs.dialog.closeModal();
    },

    select(value) {
      this.$emit('selectChoice', value);
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

.choice-box {
  background: $very-light-grey;
  border: 1px solid black;
  border-radius: 5px;
}

.choice-border {
  border: 1px solid;
  border-radius: 3px;
  padding: 0px;
  margin: 0px;
  width: 42px;
  height: 42px;
  margin-right: 16px;
}

.choice-column {
  display: flex;
  flex-direction: row;
  width: 100%;
}
</style>
